import { DATA_LAYER_NAME } from './constants';

const resolveTarget = (target) => {
  if (target) return target;
  if (typeof globalThis === 'undefined' || !globalThis.window) return null;
  return globalThis.window;
};

const clonePayload = (payload = {}) => {
  const nextPayload = { ...payload };

  if (payload.meta && typeof payload.meta === 'object' && !Array.isArray(payload.meta)) {
    nextPayload.meta = { ...payload.meta };
  }

  return nextPayload;
};

export const isDataLayerAvailable = (target) => !!resolveTarget(target);

export const getDataLayer = (target) => {
  const resolvedTarget = resolveTarget(target);

  if (!resolvedTarget) return null;

  if (!Array.isArray(resolvedTarget[DATA_LAYER_NAME])) {
    resolvedTarget[DATA_LAYER_NAME] = [];
  }

  return resolvedTarget[DATA_LAYER_NAME];
};

export const pushToDataLayer = (payload, options = {}) => {
  if (!payload || typeof payload !== 'object') return null;

  const dataLayer = getDataLayer(options.target);

  if (!dataLayer) return null;

  const safePayload = clonePayload(payload);
  dataLayer.push(safePayload);

  return safePayload;
};
